import { useQuery } from '@apollo/client';
import {
  PAGAMENTO_POR_ID,
  PagamentoPorIdData,
  PagamentoPorIdVars,
} from '../services/pagamentoInscricaoService';
import {
  LIGA_CONTA_IUGU_POR_LIGA_ID,
  LigaContaIuguPorLigaIdData,
  LigaContaIuguPorLigaIdVars,
} from '../services/ligaContaIuguService';

export interface UsePagamentoComStatusContaIuguResult {
  pagamento: PagamentoPorIdData['pagamentoInscricaoPorId'] | undefined;
  inscricoes: PagamentoPorIdData['pagamentoInscricaoPorId']['inscricoes'];
  ligaId: string | null;
  ligaContaIuguAtiva: boolean;
  loading: boolean;
  error: Error | undefined;
  refetch: () => void;
}

/**
 * Hook que retorna dados do pagamento e o status da conta Iugu da Liga.
 * LigaContaIuguAtiva é true apenas quando a Liga tem conta verificada E ativa.
 */
export const usePagamentoComStatusContaIugu = (
  pagamentoId: string | undefined
): UsePagamentoComStatusContaIuguResult => {
  const {
    data: pagamentoData,
    loading: pagamentoLoading,
    error: pagamentoError,
    refetch: refetchPagamento,
  } = useQuery<PagamentoPorIdData, PagamentoPorIdVars>(PAGAMENTO_POR_ID, {
    variables: { id: pagamentoId || '' },
    skip: !pagamentoId,
  });

  const pagamento = pagamentoData?.pagamentoInscricaoPorId;
  const inscricoes = pagamento?.inscricoes ?? [];
  const ligaId =
    inscricoes[0]?.categoriaTorneio?.torneio?.ligaId ?? null;

  const { data: contaIuguData } = useQuery<
    LigaContaIuguPorLigaIdData,
    LigaContaIuguPorLigaIdVars
  >(LIGA_CONTA_IUGU_POR_LIGA_ID, {
    variables: { ligaId: ligaId! },
    skip: !ligaId,
  });

  const contaIugu = contaIuguData?.ligaContaIuguPorLigaId;
  const ligaContaIuguAtiva =
    !!(contaIugu?.verificada && contaIugu?.ativa);

  return {
    pagamento: pagamento ?? undefined,
    inscricoes,
    ligaId,
    ligaContaIuguAtiva,
    loading: pagamentoLoading,
    error: pagamentoError,
    refetch: () => refetchPagamento(),
  };
};
